import {CREDITS_LIST, TEAMS_LIST} from "./type";

const initalState = {
  creditsList: [],
  teamsList: []
};

const creditPolicyReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREDITS_LIST:
      return {
        ...state,
        creditsList: payload,
      };
    case TEAMS_LIST:
      return {
        ...state,
        teamsList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default creditPolicyReducer;
